import { useQuery } from '@tanstack/react-query';
import { Link, useSearchParams } from 'react-router';
import { type ApiError, api, qs, unwrap } from '../api/client';
import type { Account } from '../api/types';
import { ErrorAlert, PageHeader } from '../components/ui';

/** SEC-09: where Instagram sends the browser back; completes the connection with the user's session. */
export function ConnectCallbackPage() {
  const [params] = useSearchParams();
  const code = params.get('code');
  const state = params.get('state');
  const result = useQuery({
    queryKey: ['connect-callback', code, state],
    queryFn: () =>
      unwrap(api.get<Account>(`/portal/social-accounts/callback${qs({ code, state })}`)),
    enabled: code !== null && state !== null,
    retry: false,
  });
  return (
    <div className="auth-shell">
      <PageHeader title="Connecting Instagram" subtitle="Finishing the connection with Instagram" />
      {code === null || state === null ? (
        <div className="alert alert-error">
          Instagram did not send a code back ({params.get('error_description') ?? 'cancelled'}).
        </div>
      ) : null}
      {result.isPending && code !== null && state !== null ? (
        <p className="muted">One moment…</p>
      ) : null}
      <ErrorAlert error={result.error as ApiError | null} />
      {result.data ? (
        <div className="alert alert-success">
          Connected @{result.data.username}. <Link to="/app/accounts">Back to Social Accounts</Link>
        </div>
      ) : (
        <p>
          <Link to="/app/accounts">Back to Social Accounts</Link>
        </p>
      )}
    </div>
  );
}
